import React from 'react'

const GradientButton = ({ onClick, className = "", children, disabled = false }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`relative overflow-hidden bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-2 rounded-xl 
    font-medium transition-transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
  >
    {children}
  </button>
);

export default GradientButton
